import { Entry } from 'contentful';

import { TypeBlogPostSkeleton } from '../../../interfaces/contentful';
import { InternalLink } from '../../Clickables/InternalLink/InternalLink';
import { Container, ContainerVariants } from '../../Container/Container';
import { Heading } from '../../Heading/Heading';
import { ArrowRightIcon } from '../../Icons/ArrowRightIcon';
import { Text } from '../../Text/Text';
import { BlogPreviewCard } from '../BlogPreviewCard/BlogPreviewCard';
import { getCurrentRegion } from '../BlogPreviewCard/helpers/getCurrentRegion';
import { twMerge } from 'tailwind-merge';

interface IProps {
  blogPostItems: Entry<TypeBlogPostSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>[];
  className?: string;
  containerVariant?: ContainerVariants;
  id?: string;
  linkTo: string;
  linkToText?: string;
  showCountry?: boolean;
  speciesId?: string;
  regionId?: string;
  placeName?: string;
}

export const BlogPostSection = ({
  blogPostItems,
  className,
  containerVariant = 'thin',
  linkTo,
  linkToText = 'See related posts',
  id = 'blog-post-section',
  showCountry = false,
  speciesId,
  regionId,
  placeName,
}: IProps) => (
  <Container
    id={id}
    variant={containerVariant}
    className={twMerge('mt-sm flex flex-col items-center gap-4', className)}
  >
    <div className="mb-2 flex w-full flex-col gap-2 sm:mb-4 md:mb-6">
      <Heading as="h3" className="m-0 sm:text-center">
        Fishbrain blog
      </Heading>
      <Text className="mb-0 sm:text-center">
        Learn where to fish, when to fish, and top tips from our anglers to help you land that
        personal best
      </Text>
    </div>

    {blogPostItems.map(blogPost => {
      const {
        slug,
        title: blogPostTitle,
        postDescription,
        subjectTags,
        species,
        headerImage,
        category,
        publishDate,
        countryData,
        regionData,
      } = blogPost.fields;
      const _id = blogPost.sys.id;
      const imageUrl = headerImage?.fields.file?.url;
      const categorySlug = category?.fields.slug;
      const selectedRegion = regionId
        ? getCurrentRegion({ regionList: regionData, regionId: regionId.toUpperCase() })
        : undefined;

      return categorySlug ? (
        <BlogPreviewCard
          key={_id}
          imageUrl={imageUrl}
          categorySlug={categorySlug}
          blogPostId={_id}
          blogPostSlug={slug}
          blogPostTitle={blogPostTitle}
          blogPostDescription={postDescription}
          blogTags={subjectTags}
          species={species || undefined}
          hideDate
          publishDate={publishDate}
          country={showCountry ? countryData : undefined}
          speciesId={speciesId}
          selectedRegion={regionId ? selectedRegion : undefined}
          placeName={placeName}
        />
      ) : (
        <></>
      );
    })}
    <InternalLink
      variant="textPrimaryDarkBg"
      to={linkTo}
      className="bg-sea-foam mb-4 flex gap-2 p-4"
    >
      {linkToText} <ArrowRightIcon size={20} />
    </InternalLink>
  </Container>
);
